import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import Cadastro from './components/Cadastro';
import Login from './components/login/Login';
import Home from './screens/Home/Home';
import Contato from './components/Contato';
import Indicadores from './components/Indicadores';
import Planos from './components/Planos';
import Portfolio from './components/Portifolio';
import PublicPageLayout from './components/PublicPageLayout';
import { useAuth } from './components/auth';
import ProtectedRoute from './components/ProtectedRoute';
import PageLoading from './components/PageLoading';
import './public-theme.css';

const Dashboard = lazy(() => import('./components/Dashboard/Dashboard'));
const UserDashboard = lazy(() => import('./components/UserDashboard/UserDashboard'));
const Results = lazy(() => import('./components/Results/Results'));

function App() {
  const { logout, user } = useAuth();

  return (
    <ErrorBoundary>
      <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cadastro" element={<Cadastro />} />
        <Route path="/login" element={<Login />} />
        <Route path="/planos" element={<PublicPageLayout><Planos /></PublicPageLayout>} />
        <Route path="/indicadores" element={<PublicPageLayout><Indicadores /></PublicPageLayout>} />
        <Route path="/portifolio" element={<PublicPageLayout><Portfolio /></PublicPageLayout>} />
        <Route path="/resultados" element={<Navigate to="/resultados/ragnarok" replace />} />
        <Route path="/resultados/ragnarok" element={<PublicPageLayout><Results /></PublicPageLayout>} />
        <Route path="/portfolio" element={<Navigate to="/portifolio" replace />} />
        <Route path="/contato" element={<PublicPageLayout><Contato /></PublicPageLayout>} />

        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute role="admin">
              <Dashboard logout={logout} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard-cliente/*"
          element={
            <ProtectedRoute role="user">
              <UserDashboard userId={user?.id} />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
